import { Image, type ImageProps } from '@frontend/components';

export interface ThumbnailImageProps extends Omit<ImageProps, 'alt'> {
  src: string;
  alt?: string | null;
}

export const ThumbnailImage = ({ alt, ...restProps }: ThumbnailImageProps) => {
  return (
    <Image
      data-fs-hide="true"
      height="auto"
      maxHeight="100%"
      maxWidth="100%"
      objectFit="cover"
      userSelect="none"
      verticalAlign="middle"
      alt={alt || 'Thumbnail image of part'}
      {...restProps}
    />
  );
};
